import { IconButton, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CaretLeftIcon } from "@phosphor-icons/react/dist/csr/CaretLeft";
import { useNavigate } from "react-router-dom";
import { useAccountContext } from "../../strict/app/AccountResolver";
import useAuth from "../../context/UserContext";
import { getUrlName } from "../../lib/Util";
import { AccountMenu } from "../AccountMenu";
import { DocsButton } from "../ui/buttons";
import { UserMenu } from "../UserMenu/UserMenu";

const StickyHeader = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  position: "sticky",
  top: 0,
  zIndex: theme.zIndex.drawer - 1,
  border: `1px solid ${theme.palette.surfaceLight30.main}`,
  borderBottom: `1px solid ${theme.palette.surfaceLight40.main}`,
  padding: "20px 64px 20px 24px",
  backgroundColor: theme.palette.surfaceLight20.main,
}));

export const Header = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { urlName: ctxUrlName } = useAccountContext();
  const urlName = getUrlName() || ctxUrlName || user.default_url_name || "";
  const handleClickMainPage = () => {
    navigate(`/app/${urlName}/dashboard`);
  };
  const isAdminPage = !window.location.hash.includes("/app/");

  return (
    <StickyHeader data-cy="header">
      <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
        <Stack direction="row" sx={{ alignItems: "center" }}>
          {urlName && isAdminPage ? (
            <IconButton onClick={handleClickMainPage} data-testid="back-button">
              <CaretLeftIcon size="24px" />
            </IconButton>
          ) : (
            <AccountMenu />
          )}
        </Stack>
        <Stack direction="row" sx={{ alignItems: "center", gap: "20px" }}>
          <DocsButton />
          <UserMenu />
        </Stack>
      </Stack>
    </StickyHeader>
  );
};
